import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import { weProjectProgressData } from 'data/weraise-data/data';
import React from 'react';
import { Button, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const ProjectInProgress = () => {
  const navigate = useNavigate();
  return (
    <Card>
      <FalconCardHeader
        title={<h4 className="mt-2 fw-bold">Project Progress</h4>}
        light={false}
        titleTag="div"
        menuClassName="align-items-center"
        endEl={
          <Button onClick={() => navigate('create_report')}>Add Report</Button>
        }
      />
      <Card.Body className="bg-100">
        {weProjectProgressData?.map((item, index) => (
          <Card
            key={item.id}
            onClick={() => navigate(`${item.id}`)}
            className={classNames('cursor-pointer', {
              'mb-3': index !== weProjectProgressData?.length - 1
            })}
          >
            <Card.Body>
              <p className="text-primary fs-0 fw-semi-bold">{item.title}</p>
              <p className="fs-0">{item.description}</p>
              <Flex justifyContent={'between'}>
                <p className="mb-0 fw-medium text-1000">{item.date}</p>
                <p className="mb-0">
                  <FontAwesomeIcon icon={'user'} className="me-2 text-1000" />
                  {item.ownerName}
                </p>
              </Flex>
            </Card.Body>
          </Card>
        ))}
      </Card.Body>
    </Card>
  );
};

export default ProjectInProgress;
